<template>
    <console-content max-width="1280">
        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="py-0 headline text-start">구매 상세정보</v-col>
            <v-spacer />
        </v-row>

        <v-card v-bind="{ loading }" :disabled="!$hasScope(['root','admin'])" class="mx-1 mt-4">
            <v-card-title class="subtitle-2 font-weight-bold">
                <v-icon small class="mr-2" color="blue">{{ mdiMinusThick }}</v-icon
                >기본정보
                <v-spacer />
                <v-divider vertical class="mx-2 my-1" />
                <span class="caption grey--text">주문번호</span>
                <v-divider vertical class="mx-2 my-1" />
                <span class="body-2">{{ order.orderNo }}</span>

                <v-divider vertical class="ml-3 my-1" />
                <span class="caption grey--text ml-2">상품명</span>
                <v-divider vertical class="mx-2 my-1" />
                <span class="body-2">{{ order.name }}</span>
                <v-btn text icon :to="`/console/shop/delivery/products/${order._product}`"
                    ><v-icon small>{{ mdiLink }}</v-icon></v-btn
                >

                <v-divider vertical class="ml-3 my-1" />
                <span class="caption grey--text ml-2">총 수량</span>
                <v-divider vertical class="mx-2 my-1" />
                <span class="body-2">{{ order.quantity }}개</span>

                <v-divider vertical class="ml-3 my-1" />
                <span class="caption grey--text ml-2">총 구매금액</span>
                <v-divider vertical class="mx-2 my-1" />
                <span class="body-2">{{ order?.totalAmount?.format?.() }}원</span>

                <v-divider vertical class="ml-3 my-1" />
                <span class="caption grey--text ml-2">주문일시</span>
                <v-divider vertical class="mx-2 my-1" />
                <span class="body-2">{{ order.createdAt.toDateTime() }}</span>
            </v-card-title>
            <v-divider />
            <v-data-table :items="order.purchases" :headers="ordersHeaders" hide-default-footer disable-sort class="mx-1">
                <template #[`item.product`]="{ item }">
                    <v-row v-if="item.product" align="center">
                        <v-col md="auto">
                            <v-img v-if="item.curProduct.thumb" :src="item.curProduct.thumb" max-width="96" max-height="96"></v-img>
                            <v-responsive v-else width="96" height="96">
                                <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                                    <v-icon>mdi-image</v-icon>
                                </v-row>
                            </v-responsive>
                        </v-col>
                        <v-col>
                            <div class="text-start">{{ item.fullName }}</div>
                        </v-col>
                    </v-row>
                </template>
                <template #[`item.buyer`]="{ item }">
                    <div>{{ item.buyer.name }} [{{ item.buyer.id }}]</div>
                    <div>{{ item.buyer.phone.phoneNumberFormat() }}</div>
                </template>
                <template #[`item.saleAmount`]="{ item }"> {{ item.product?.salePrice?.format?.() }}원 </template>
                <template #[`item.quantity`]="{ item }"> {{ item?.quantity?.format?.() }}개 </template>
                <template #[`item.totalAmount`]="{ item }"> {{ (item.product.salePrice * item.quantity)?.format?.() }}원 </template>
                <template #[`item.status`]="{ item }">
                    <v-select v-model="item.status" :items="statuses" v-bind="{ ...attrs_input }" />
                </template>
                <template #[`item.actions`]="{ item }">
                    <v-row>
                        <v-col v-if="!['취소완료'].includes(item.status)">
                            <v-btn small @click="cancel(item)">상품 취소</v-btn>
                        </v-col>
                        <v-col v-if="['취소완료'].includes(item.status) && item.refundedAt === '-' && item.canceledAt !== '-'">
                            <v-btn small color="red--text" @click="refund(item)">캐시 환불</v-btn>
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </v-card>

        <v-card v-bind="{ loading }" :disabled="!$hasScope(['root','admin'])" class="mt-4">
            <v-card-title class="subtitle-2 font-weight-bold"
                ><v-icon small class="mr-2" color="blue">{{ mdiMinusThick }}</v-icon
                >구매자 정보</v-card-title
            >
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="3" class="py-0">
                        <v-text-field :value="order.buyer.name" label="이름" placeholder=" " v-bind="{ ...attrs_input }" readonly />
                    </v-col>
                    <v-col cols="12" md="3" class="py-0">
                        <v-text-field :value="order.buyer.username" label="아이디" placeholder=" " v-bind="{ ...attrs_input }" readonly />
                    </v-col>
                    <v-col cols="12" md="3" class="py-0">
                        <v-text-field :value="order.buyer.phone.phoneNumberFormat()" label="연락처" placeholder=" " v-bind="{ ...attrs_input }" readonly />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-title class="subtitle-2 font-weight-bold"
                ><v-icon small class="mr-2" color="blue">{{ mdiMinusThick }}</v-icon
                >받는사람 정보</v-card-title
            >
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="3" class="py-0">
                        <v-text-field :value="order.receiver.name" label="이름" placeholder=" " v-bind="{ ...attrs_input }" readonly />
                    </v-col>
                    <v-col cols="12" md="3" class="py-0">
                        <v-text-field :value="order.receiver.phone.phoneNumberFormat()" label="연락처" placeholder=" " v-bind="{ ...attrs_input }" readonly />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-row class="my-6">
            <v-spacer />
            <v-col cols="auto" class="py-0">
                <v-btn :disabled="!$hasScope(['root','admin'])" color="primary" @click="save">저장</v-btn>
            </v-col>
            <v-spacer />
        </v-row>
    </console-content>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import { mdiMinusThick, mdiCloseCircleOutline, mdiCashRefund, mdiWalletGiftcard, mdiBarrel, mdiMicrosoftExcel, mdiLink } from "@mdi/js";
import ConsoleContent from "@/pages/console/templates/ConsoleContent.vue";
export default {
    components: {
        ConsoleContent,
    },
    data() {
        return {
            mdiBarrel,
            mdiMinusThick,
            mdiCloseCircleOutline,
            mdiCashRefund,
            mdiWalletGiftcard,
            mdiMicrosoftExcel,
            mdiLink,
            attrs_input: {
                dense: true,
                outlined: true,
                hideDetails: "auto",
                persistentPlaceholder: true,
            },

            showSearch: true,
            loading: false,

            order: null,
            ordersHeaders: [
                { text: "상품", value: "product", align: "center" },
                { text: "상품가", value: "saleAmount", align: "center" },
                { text: "수량", value: "quantity", align: "center" },
                { text: "구매금액", value: "totalAmount", align: "center" },
                { text: "상태", value: "status", width: 200, align: "center" },
                { text: "취소 시간", value: "canceledAt", align: "center" },
                { text: "환불 시간", value: "refundedAt", align: "center" },
                { text: "actions", value: "actions", width: 140, align: "center" },
            ],

            statuses: ["주문완료", "결제완료", "취소요청", "취소불가", "취소완료", "부분취소완료"],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            await this.search();
        },

        async search() {
            try {
                if (this.loading) return;
                this.loading = true;

                let { order } = await api.console.shop.delivery.orders.get({ _id: this.$route.params._order });
                this.order = this.setOrder(order);
            } catch (e) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            } finally {
                this.loading = false;
            }
        },

        async save() {
            try {
                let { purchases } = this.order;

                for (let purchase of purchases) {
                    api.console.shop.delivery.purchases.put({ _id: purchase._id, status: purchase.status });
                }

                alert("저장되었습니다");
                this.$router.go(-1);
            } catch (e) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            } finally {
                this.loading = false;
            }
        },

        async cancel(purchase) {
            try {
                if (confirm("해당 구매 건을 취소하시겠습니까?")) {
                    if (this.loading) return;
                    this.loading = true;

                    await api.console.shop.delivery.purchases.put({ _id: purchase._id, status: "취소완료", canceledAt: Date.now() });

                    alert("취소되었습니다.");
                    this.loading = false;
                    await this.search();
                }
            } catch (e) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            } finally {
                this.loading = false;
            }
        },

        async refund(purchase) {
            try {
                if (confirm("해당 구매 건을 환불하시겠습니까?")) {
                    if (this.loading) return;
                    this.loading = true;

                    await api.console.shop.delivery.purchases.refund({ _id: purchase._id, status: "취소완료" });

                    alert("환불되었습니다.");
                    this.loading = false;
                    await this.search();
                }
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            } finally {
                this.loading = false;
            }
        },

        setOrder(order) {
            const purchases = order?.purchases || [];
            return {
                ...order,
                _product: purchases[0]?.product?._mainProduct || purchases[0]?.product?._id || "",
                name: purchases[0]?.product?.name || "-",
                quantity: purchases.reduce((totalQuantity, purchase) => (totalQuantity += purchase?.quantity || 0), 0),
                purchases: purchases.map((purchase) => ({
                    ...purchase,
                    fullName: this.setOrderNameWithOptions(purchase),
                    canceledAt: purchase?.canceledAt ? this.$dayjs(purchase.canceledAt).format("YYYY-MM-DD HH:mm:ss") : "-",
                    refundedAt: purchase?.refundedAt ? this.$dayjs(purchase.refundedAt).format("YYYY-MM-DD HH:mm:ss") : "-",
                })),
            };
        },
        setOrderNameWithOptions(purchase) {
            const { product } = purchase;
            if (!product?.optionalNames.length) return purchase.product.name;
            let name = purchase.product.name;
            name += "(";
            for (const [index, option] of product.optionalNames.entries()) {
                name += `${option}: `;
                name += product.optionalValues[index];
                if (index !== product.optionalNames.length - 1) {
                    name += "/";
                }
            }
            name += ")";

            return name;
        },
    },
};
</script>